import React from 'react';
import { Icon } from './Icon';
import { screensFor } from './model';

const CATEGORY_LABELS = ['Vos informations', 'Le prix', 'La visite'];
const categoryFor = (screen) => (screen === 'prix' ? 1 : screen === 'visite' ? 2 : 0);

export const SimulatorHeader = ({ data, screen, complete }) => {
  const screens = screensFor(data);
  const index = screens.indexOf(screen);
  const fraction = complete ? 1 : (index + 1) / screens.length;
  const category = complete ? 2 : categoryFor(screen);
  return <header className="sim-header">
    <div className="sim-brand-row"><div className="sim-wordmark" data-testid="brand"><span className="sim-brand-icon"><Icon name="house" size={22} /></span>EB <strong>ENERGIE</strong></div><span className="sim-location"><Icon name="pin" size={14} /> Montpellier &amp; ses environs</span></div>
    <div className="sim-progress-track" role="progressbar" aria-label="Progression du devis" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(fraction * 100)} data-testid="dpe-progress">
      {[0, 1, 2].map((segment) => <span key={segment} className="sim-progress-seg" data-testid={`progress-seg-${segment}`}><span style={{ width: `${Math.max(0, Math.min(1, fraction * 3 - segment)) * 100}%` }} /></span>)}
    </div>
    <p className="sim-progress-label" data-testid="progress-label">{CATEGORY_LABELS[category]}</p>
  </header>;
};
